import { ChangeDetectorRef, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ContentService } from '../../spartacus/services/content.service';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { codeValidation } from '../materialslanding/code.validator';
import { MaterialsUKService } from '../materialsuk-service';
import { MatTableDataSource } from '@angular/material/table';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { ApiFailureDialogService } from '../../api-failure-dialog/api-failure-dialog.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
declare var clickToAddress:any;
@Component({
  selector: 'app-mymaterials-prebook',
  standalone: false,
  templateUrl: './mymaterials-prebook.component.html',
  styleUrl: './mymaterials-prebook.component.scss'
})
export class MymaterialsPrebookComponent {
  data: Observable<any> = this.component.data$;
  dataSourcemain: any = [];
  displayAddressForm = false;
  isLoading:boolean=false;
  selectedAccount: string = '';
  newdata: any;
  locationplace:boolean=true;
  cc: any;
  count:number=0;
  enableSubmit = false;
  thankyou:boolean=false;
  showback = false;
  submitblock:boolean=false;
  cardsList: any;
  isSubmitted = false;
  selected: string | null = null;
  locationsection:boolean=false;
  landingprebook:boolean=true;
  activeIndex = -1;
  allOpen = false;
  requestNumber: any;
  userConsent = false;
  displayedColumns: string[] = [
    'checkbox',
    'shippingOrganizationName',
    'shippingAddressLine1',
    'col4',
    'orderExists'
  ];
  dataSource: any;
  isAsmUser: boolean = false;

  addressForm = new FormGroup({
    organizationName: new FormControl('',[Validators.pattern("^[A-Za-z\\s]+$")]),
    address: new FormControl(''),
    line1: new FormControl('', [Validators.required]),
    city: new FormControl('', [
      Validators.required,
      Validators.pattern('^[a-zA-Z]+$'),
    ]),
    code: new FormControl('', [Validators.required, codeValidation()]),
    country: new FormControl('', [
      Validators.required,
      Validators.pattern('^[a-zA-Z ]+$'),
    ]),
  });
  digitalUserConsent = false;
  sentDigitalConsent = false;
  digitalUserConsentdata: any = [];
  disableCheckbox = false;
  digitConsent = false;
  marketingConsent = false;
  materailwholedata: any = [];
  materailblockdata: any = [];
  isUserLoggedIn: boolean = false;
  userInfo: any;
  constructor( private gtmService: GoogleTagManagerService,private dialogservice:ApiFailureDialogService,public userInfoService: UserInfoService,public component: CmsComponentData<CmsBannerComponent>, public contentService: ContentService, public cd: ChangeDetectorRef, protected config: OccConfig, private materialsUkService: MaterialsUKService) { }
  ngOnInit() {
    this.submitblock=false;
    this.data.subscribe(res => {
     this.popupList(res);
    });
    this.userInfoService.userLoggedIn$.subscribe((res) => {
      this.isUserLoggedIn = res;
      if (this.isUserLoggedIn) {
        this.userInfoService.getUserData().subscribe((res) => {
          if (res) {
            this.userInfo = res;

            localStorage.setItem('webEnabled', this.userInfo.webEnabled);
            this.selectedAccount = this.userInfo.orgUnit.uid;
          }
        });
      }
    });
 
    this.materialsUkService
    .getShippingLocationData()
    .subscribe((data: any) => {
      this.newdata = data?.materialsShipping;
      this.dataSource = new MatTableDataSource(data?.materialsShipping);
      this.cd.detectChanges();
    });
    this.materialsUkService.getmaterailData().subscribe((data: any) => {
      this.materailwholedata = data;
      this.cd.detectChanges();
    });
    this.materialsUkService.getmaterailblock().subscribe((data: any) => {
      this.materailblockdata = data;
      this.digitConsent = String(data.digitConsent).toLowerCase() === 'true';
      this.marketingConsent = String(data.marketingConsent).toLocaleLowerCase() === 'true';
      this.cd.detectChanges();
    });

    this.isAsmUser = this.userInfoService.checkAsmUser();

  }
  ngAfterViewInit(): void {
    if(!this.cc){
      //this.cc = this.registrationUkService.fetchifyCallUK();
      this.cc = new clickToAddress({
        accessToken: '7669a-89946-0db5f-06dae',
        countryMatchWith: 'text',
        enabledCountries: ['United Kingdom'],
        domMode: 'id',
        gfxMode: 1,
        style: {
          ambient: 'light', // Use white as main interface color
          accent: 'default', // Use default secondary color for interface
        },
        texts: {
          default_placeholder: 'Start with post/zip code or street',
        },
        showLogo: true,
        disableAutoSearch: false,
      });
    }
  }

  onDigitalConsentChange(value: boolean) {
    if (value) {
      this.materialsUkService.getDigitalConsent('true').subscribe((res: any) => {
        if (res === 'SUCCESS') {
          this.digitalUserConsent = true;
          this.disableCheckbox = true;
        } else {
          this.digitalUserConsent = false;
        }
      });
    }
  }

  setFetchify(){
    this.cc.attach(
      {
        search: 'address',
        town: 'city',
        postcode: 'code',
        line_1: 'line1',
        country: 'country'
      },
      {
        onResultSelected: (c2a: any, elements: any, address: any) => {
          this.addressForm.controls['line1']?.setValue(address.line_1);
          this.addressForm.get('line1')?.markAsTouched();
          this.addressForm.controls['city']?.setValue(address.locality);
          this.addressForm.get('city')?.markAsTouched();
          this.addressForm.controls['code']?.setValue(address.postal_code);
          this.addressForm.get('code')?.markAsTouched();
          this.addressForm.controls['country']?.setValue(address.country_name);
          this.addressForm.get('country')?.markAsTouched();
          this.addressForm.updateValueAndValidity();
          this.cd.detectChanges();
        },
      }
    );
  }
  getFormControl(control: string) {
    return this.addressForm!.get(control);
  }

  toggleinput(element?: any) {
    //this.showinput=true;
    element.displayAdd = true;
  }
  displayAddress() {
    this.displayAddressForm = !this.displayAddressForm;
    setTimeout(()=> {
      this.setFetchify();
    },100)
  }

  popupList(res: any) {
    const tilesList = res?.SeqirusTeaserList?.split(" ");
    if (tilesList) {
      this.contentService.opeffeaturedResources(tilesList).subscribe((res: any) => {
        this.cardsList = res.component.sort((a: any, b: any) => Number(a.materialCode) - Number(b.materialCode));
        this.cd.detectChanges();
      });
    }
  }
  toggle(location: string) {
    this.selected = this.selected === location ? null : location;
  }
  getImage(image: any) {
    return this.config.backend?.occ?.baseUrl + image.url;
  }

  openPopup(materialCode: number, event: MouseEvent,attr:string) {
    event.stopPropagation(); 
    //this.activeIndex = (this.activeIndex === index) ? -1 : index;
    const index = this.cardsList.findIndex((item: any) => item.materialCode == materialCode.toString());
    if(this.activeIndex!=-1 && this.activeIndex != index){
   const value=this.gtmpush();
      const gtmTag = {
        event: 'discover_material',
        discover_name: value+ '_closed',
        }
        this.gtmService.pushTag(gtmTag)
    }
   

    if(this.activeIndex === index){
      this.activeIndex =-1;
      const gtmTag = {
        event: 'discover_material',
        discover_name: attr+ '_closed',
        }
        this.gtmService.pushTag(gtmTag)

    }else{
      this.activeIndex =index;
      const gtmTag = {
        event: 'discover_material',
        discover_name: attr+ '_open',
       
        }
        this.gtmService.pushTag(gtmTag)
    }
    
  }

  gtmpush(){
    let value=""
    if(this.activeIndex==0){
value="waiting_room"
    }else if(this.activeIndex==1){
      value="consultation_room"
    }else if(this.activeIndex==2){
 value="reception_area"
    }else if(this.activeIndex==3){
 value="outside_clinic"
    }
    return value;
  }
  closePopup() {
  const value=this.gtmpush();
  if(this.activeIndex != -1){
    const gtmTag = {
      event: 'discover_material',
      discover_name: value+ '_closed',
      }
      this.gtmService.pushTag(gtmTag)
    }
    this.activeIndex = -1;
  }
  getIndex(materialCode: number) {
    return this.cardsList.findIndex(
      (item: any) => item.materialCode == materialCode.toString()
    );
  }
  toggleAll() {
    this.allOpen = !this.allOpen;
  }
  scrollToSection(sectionId: string, event: Event) {
    event.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.addressForm.invalid) {
      return;
    }
    this.count++;
    this.displayAddress();
    const newAddress = {
      checked: true,
      shippingOrganizationName:
        this.addressForm.controls.organizationName.value,
      shippingAddressLine1: this.addressForm.controls.line1.value,
      town: this.addressForm.controls.city.value,
      postalCode: this.addressForm.controls.code.value,
      selected: true,
      locationId:'Newlocation'+this.count,
    };

    this.newdata.push(newAddress);
  
   /*  const location=this.newdata.find((data:any)=>data.locationId==newAddress.locationId);
    if(location){
      if(location.checked && location.selected){
        location.checked=false;
        location.selected=false;
      }else{
        location.checked=true;
        location.selected=true;
      }
    } */
  this.locationplace=false;
    this.dataSource.data = this.newdata;
    this.addressForm.reset();
    this.isSubmitted=false;
    this.cd.detectChanges();
  }

  handleoncheck(event:any){
    
    if (event.target.checked) {
      
      const rowcheck=this.newdata.find((row:any)=>row.checked==true)
      if(rowcheck){
        this.enableSubmit =  true ;
        }else{
          this.enableSubmit=false;
        }
   
    }else{
      
      this.enableSubmit=false;
    }
    this.cd.detectChanges();
  }
  rowSelected(row: any) {
    const location=this.newdata.find((data:any)=>data.locationId==row.locationId);
    if(location){
      if(location.checked && location.selected){
        location.checked=false;
        location.selected=false;
      }else{
        location.checked=true;
        location.selected=true;
      }
    }
  this.locationplace=false;
  this.dataSource.data =this.newdata;

 
  
       
  }
  continuebtn(){    
    if (this.mybasketmaterial?.length === 0) {
      return;
    }

    this.locationsection=true;
    this.landingprebook=false;
    this.scrollToTop();
    this.cd.detectChanges();

  }
  backtolanding(){
this.locationsection=false;
this.landingprebook=true;
this.scrollToTop();
this.cd.detectChanges();
  }


  addedBundles = new Set<string>();
  isBundleAdded(code: string): boolean {
    return this.addedBundles.has(code);
  }
  mybasketmaterial: any[] = [];
  addBundle(bundleCode: string): void {
    // Prevent adding the same bundle twice
    if (this.addedBundles.has(bundleCode)) {
      return;
    }
    this.addedBundles = new Set<string>();
    //else iam adding the bundle
    this.addedBundles.add(bundleCode);
    //iam finding in the wholedata where the code is matched
   // const bundle = this.materailwholedata.find((x: any) => x.code === bundleCode);
    //if i didnt find any iam just returning
    //if (!bundle) return;
    //now in the bundleProducts iam keeing my bundleproducts object
    //const bundleProducts = bundle.bundleProducts;
    //object iam converting into array and looping
   /*  Object.entries(bundleProducts).forEach(([productId, qty]) => {
     
      let existing = this.mybasketmaterial.find(p => p.code === productId);
      if (!existing) {
        existing = {
          code: productId,
          quantity: 0
        };
        this.mybasketmaterial.push(existing);
      }
      existing.quantity += Number(qty);

     console.log( this.mybasketmaterial)
    }); */
 
    let existing ={
      code: bundleCode,
      quantity: 1
    }
    this.mybasketmaterial=[];
    this.mybasketmaterial.push(existing);
    console.log( this.mybasketmaterial)

  }
  scrollToTop(): void {
    window.scrollTo({ top: 300, behavior: 'smooth' });
  }

  removeBundle(bundleCode: string): void {
    //iam checking whether the bundle is existing in the addedbundle if its not then iam simply returning
    if (!this.addedBundles.has(bundleCode)) {
      return;
    }
    //otherwise iam deleting the bundle
    this.addedBundles.delete(bundleCode);
   /*  const bundle = this.materailwholedata.find((x: any) => x.code === bundleCode);
    if (!bundle) return;
    const bundleProducts = bundle.bundleProducts;
    Object.entries(bundleProducts).forEach(([productId, qty]) => {
      let existing = this.mybasketmaterial.find(p => p.code === productId);
      if (!existing) return; 
      const subtractQty = Number(qty);
    
      existing.quantity -= subtractQty;
      if (existing.quantity <= 0) {
        this.mybasketmaterial = this.mybasketmaterial.filter(
          p => p.code !== productId
        );
      }

    }); */
    let existing = this.mybasketmaterial.find(p => p.code === bundleCode);
    if (!existing) return; 
    if (existing) {
      this.mybasketmaterial = this.mybasketmaterial.filter(
        p => p.code !== bundleCode
      );
    }
    console.log( this.mybasketmaterial)
  }

  get isContinueDisabled(): boolean {
    return this.mybasketmaterial.length === 0;
  }
  marketingConsentGiven = false;
  placematerial() {
    const selectedAddress = this.dataSource.data.filter(
      (ele: any) => ele.checked
    );
  
     if(selectedAddress?.length==0){
      return ;
    }
    if(this.submitblock==true){
      return;
    }
    this.locationplace=true;
    this.isLoading=true;
    const productsList = this.mybasketmaterial.map((ele:any) => {
      return {
        materialID: ele.code,
        qty: ele.quantity,
      };
    });
    const requestData = {
      productDetails: productsList,
      soldToID: this.selectedAccount,
      ...(this.marketingConsentGiven ? { marketingConsentGiven: true } : {}),
  customerAddress: selectedAddress.map((location: any) => ({
    shipToId: location.locationId,
    company: location.shippingOrganizationName,
    line1: location.shippingAddressLine1,
    line2: location.shippingAddressLine2,
    town: location.town,
    postalCode: location.postalCode,
    country: ''
  })),
      
    };
    this.requestNumber =
      this.materialsUkService.submitMaterialData(requestData).subscribe((res:any)=>{
       
        if(res.includes("Error") && localStorage.getItem('FailureDailog') != 'true'){
          this.isLoading=false;
          this.dialogservice.openErrorDialog();
          localStorage.setItem('FailureDailog', 'true');
          this.cd.detectChanges();
        }else{
          this.isLoading=false;
          this.submitblock=true;
          this.scrollToTop();
          this.thankyou=true;
          this.locationsection=false;
          this.landingprebook=false;
            this.cd.detectChanges();
        }
   
      }, (error) => {
        console.log('error: ', error);
        this.submitblock=true;
        this.isLoading = false;
        this.cd.detectChanges();
      }
    );
    //this.dataSource.data = [...selectedAddress];
  }


}
